<template>
  <div class="search-content">
    <van-sticky>
      <div class="top-box">
        <div class="search-header">
          <div class="search">
            <div class="left">
              <form style="width:100%;" action="javascript:return true">
                <van-search autofocus ref="fieldPhone" @search="handleSearch" type="search" v-model="keyword" clearable placeholder="请输入搜索内容">
                  <template #left-icon>
                    <icon-svg class="searchIcon" name="icon_search" />
                  </template>
                </van-search>
              </form>
            </div>
            <div class="line"></div>
            <div @click="handleSearch" class="searchButton">搜索</div>
          </div>
        </div>
        <van-tabs class="tabs-box" :title-active-color="'#333333'" :title-inactive-color="'#999999'" :color="'#333333'" v-model="activeName" @change="tabChange">
          <van-tab title="全部" name="ALL"></van-tab>
          <!-- <van-tab title="医院" name="HOSPITAL"></van-tab> -->
          <van-tab title="产品" name="PROD"></van-tab>
          <van-tab title="解决方案" name="SOLUTION"></van-tab>
          <van-tab title="服务" name="SERVICE"></van-tab>
        </van-tabs>

      </div>
    </van-sticky>

    <div class="result" :class="{'nodata-bg':(activeName ==='ALL' || activeName ==='SERVICE') && showNodata}">
      <van-loading v-if="loading" class="loading-box" type="spinner" />
      <van-list v-if="list.length" :key="listKey" v-model="loading" :finished="finished" finished-text="没有更多了" @load="getList">

        <div v-for="item in list" :key="item.api_id" class="api-card" @click="goDetail(item)">
          <div class="top">
            <div class="title" v-html="item.title"></div>
            <div class="tag">{{typeFn(item.type)}}</div>
          </div>
          <div class="info">
            <div class="hospital" v-if="item.type==='HOSPITAL'">
              <div class="item">
                <icon-svg class="icon" name="icon_grade" />
                <span class="text">{{item.hospital_grade}}</span>
              </div>
              <div class="item">
                <icon-svg class="icon" name="icon_address" />
                <span class="text">{{item.address?item.address:'-'}}</span>
              </div>
            </div>

            <!-- <div class="service" v-if="item.newType==='SERVICE'">
              <img class="img" src="../../assets/images/agent/img1.png" alt="">
              <div v-html="item.brief_info" class="text"></div>
            </div> -->
            <div class="product" v-if="item.type!=='HOSPITAL'">
              <div v-html="item.brief_info" class="text"></div>
            </div>
          </div>
        </div>
      </van-list>

      <div class="empty" v-if="(activeName !=='ALL' && activeName !=='SERVICE') && showNodata">
        <icon-svg class="icon" name="noData"></icon-svg>
        <p class="empty-text">{{noDataFn()}}</p>
      </div>
      <div class="empty-pc" v-if="(activeName ==='ALL' || activeName ==='SERVICE') && showNodata">
        <p class="top-text">
          哎呀，您想找的服务没在这里。<br />
          去电脑端看看吧~
        </p>
        <icon-svg class="icon-no" name="noData"></icon-svg>
        <div class="pc-info">
          <pc-guide class="pc-component"></pc-guide>
          <div class="btn-box" @click="toPublish('myNeeds')">
            提出您的需求，我们来满足
          </div>
          <div class="have" @click="toPublish">
            <span class="text"> 我有这个服务，我要卖 </span>
            <icon-svg class="icon" name="arrow-right"></icon-svg>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { mapState } from "vuex";
import pcGuide from "@/components/pc_guid";

// import navBar from "../../components/navBar";
// import backTop from "../../components/back-top";
// import publishNeed from "../../components/publish-need";
export default {
  name: "index",
  components: {
    pcGuide,
    // navBar,
    // backTop,
    // publishNeed,
  },
  data() {
    return {
      showNodata: false,
      noData: "没有搜索到相关产品",
      activeName: "ALL",
      list: [],
      listKey: Math.random(),
      loading: false,
      finished: false,
      categoryIsShow: false,
      categoryCode: ["0"],
      category: "0",
      selectCategory: "全部分类",
      // 级联配置
      fieldNames: {
        text: "name",
        value: "code",
        children: "children",
      },
      // 级联选项列表，children 代表子选项，支持多级嵌套
      options: [],
      keyword: "",
      page: 1,
      size: 10,
      total: 0,
    };
  },
  computed: {
    ...mapState("dic", ["ossPath"]),
    ...mapState("dic", ["hospitalLevel"]),
    IMAGE_URL() {
      return this.ossPath + "/";
    },
  },
  watch: {
    // "$route.query": {
    //   immediate: true,
    //   deep: true,
    //   handler(newValue) {
    //     // if (newValue.type) {
    //     //   let name = newValue.type;
    //     //   if (name === "APIS" || name === "API" || name === "H5") {
    //     //     name = "SERVICE";
    //     //   }
    //     //   this.activeName = name;
    //     // }
    //     if (newValue.keyword) {
    //       this.keyword = newValue.keyword;
    //       this.tabChange();
    //     }
    //     // this.category = newValue.category || "0";
    //     // this.categoryCode = newValue.categoryCode || ["0"];
    //     // this.selectCategory = newValue.selectCategory || "全部分类";
    //   },
    // },
  },
  created() {
    // this.$api
    //   .CATEGORY_LIST({ category_code: "PRODUCT_CATEGORY" })
    //   .then((res) => {
    //     let options = [
    //       {
    //         code: "0",
    //         name: "全部",
    //       },
    //       ...res,
    //     ];
    //     this.options = options;
    //   });
  },
  activated() {
    // if (!this.keyword) {
    //   console.log('999');
    //   this.tabChange();
    // }
  },
  mounted() {
    // this.$nextTick(() => {
    //   this.$refs.fieldPhone.focus();
    // });
    // this.keyword = this.$route.query.keyword;
    // console.log("this.$route.query.keyword;", this.$route.query.keyword);
    // this.tabChange();
  },
  methods: {
    toPublish(n) {
      const keyword = this.keyword.replace(/\s+/g, "");
      if (n === "myNeeds") {
        this.$router.push({
          path: "/needsPublish",
          query: { keyword: keyword },
        });
        return;
      }
      this.$router.push({ path: "/publish", query: { keyword: keyword } });
    },
    tabChange() {
      this.page = 1;
      this.list = [];
      this.showNodata = false;
      // this.finished = false;
      this.getList();
    },
    typeFn(n) {
      switch (n) {
        case "SOLUTION,":
          return "解决方案";
        // break;
        case "HOSPITAL":
          return "医院";
        case "PROD":
          return "产品";
        case "SOLUTION":
          return "解决方案";
        case "APIS":
        case "API":
        case "H5":
          return "服务";
        default:
          return "";
      }
    },
    noDataFn() {
      switch (this.activeName) {
        case "ALL":
          return (this.noData = "没有搜索到相关产品");
        // break;
        case "HOSPITAL":
          return (this.noData = "没有搜索到相关医院");
        // break;
        case "PROD":
          return (this.noData = "没有搜索到相关产品");
        // break;
        case "SOLUTION":
          return (this.noData = "没有搜索到相关解决方案");
        // break;
        case "SERVICE":
          return (this.noData = "哎呀，您想找的服务没在这里。去电脑端看看");
        // break;
        default:
          return (this.noData = "哎呀，您想找的服务没在这里。去电脑端看看");
        // return this.noData;
      }
    },
    handleSearch() {
      this.tabChange();
    },
    // resetListData() {
    //   this.page = 1;
    //   this.total = 0;
    //   this.loading = false;
    //   this.finished = false;
    //   this.list = [];
    //   this.listKey = Math.random();
    // },
    showCategory() {
      this.categoryIsShow = true;
    },
    // onFinish({ selectedOptions }) {
    //   this.categoryIsShow = false;
    //   this.selectCategory = selectedOptions
    //     .map((option) => option.name)
    //     .join("/");
    //   this.categoryCode = selectedOptions.map((option) => option.code);
    //   this.resetListData();
    // },
    getList() {
      let keyword = this.keyword.replace(/\s+/g, "");
      if (!keyword) {
        this.showNodata = true;
        // this.$toast("请输入查询关键字");
        return;
      }
      if (keyword.length > 50) {
        keyword = this.keyword.slice(0, 50);
      }

      this.loading = true;

      this.$api
        .PRODUCT_SEARCH({
          search_type: this.activeName,
          keywords: keyword,
          page: this.page,
          size: this.size,
        })
        .then((res) => {
          this.loading = false;
          const replaceReg = new RegExp(this.keyword, "ig");
          const replaceString = `<span style="color: #3476FE">${this.keyword}</span>`;

          //    res.content.push({title:"南京母婴医院",description:'产检报告解读功能。免开发母婴对接，拓展业务边界，快速吸业务,产检报告解读母婴功能。免开发对接，拓展业务边界，快速吸'})
          res.content.forEach((item) => {
            if (item.hospital_grade_code) {
              let v = this.hospitalLevel.find(
                (x) => x.code === item.hospital_grade_code
              );
              if (v) {
                item.hospital_grade = v.name;
              }
            }
            if (
              item.type === "APIS" ||
              item.type === "API" ||
              item.type === "H5"
            ) {
              item.newType = "SERVICE";
            }
            item.title = item.title.replace(replaceReg, replaceString);
            if (item.brief_info) {
              item.brief_info = item.brief_info.replace(
                replaceReg,
                replaceString
              );
            }
          });
          //    console.log(res.content)

          this.list = this.list.concat(res.content);
          this.total = res.total;
          if (this.list.length >= res.total || !res.content.length) {
            this.finished = true;
          } else {
            this.page++;
          }
          if (!this.list.length) this.showNodata = true;
        })
        .catch(() => {
          this.finished = true;
          this.loading = false;
          this.showNodata = true;
        });
    },
    goDetail(item) {
      let path = "";
      switch (item.type) {
        case "HOSPITAL":
          path = "/hospital";
          break;
        case "PROD":
        case "SOLUTION":
          path = "/solution";
          break;
        // case "SOLUTION":
        //   path = "/solution";
        //   break;
        case "H5":
          path = "/service";
          break;
        default:
          path = "/apiDetail";
      }
      this.$router.push({
        path: path,
        query: {
          api_id: item.id,
          type: item.type,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.search-content {
  background: #fff;
  box-sizing: border-box;
  height: 100%;
  padding-bottom: 50px;
  ::-webkit-search-cancel-button {
    display: none;
  }
  input::-ms-clear {
    display: none;
  }
  input::-ms-reveal {
    display: none;
  }
  input[type="search"]::-webkit-search-cancel-button {
    -webkit-appearance: none;
  }
  .top-box {
    // height: 120px;
    padding: 20px 12px 0px;
    background: rgb(255, 255, 255);
    box-sizing: border-box;
    box-shadow: 0px 4vw 8vw 0px rgba(0, 0, 0, 0.05);
    position: relative;
    z-index: 50;
    .search-header {
      //   padding: 20px 12px;
      background: #fff;
    }
    .search {
      padding: 0 15px 0 11px;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      height: 46px;
      background: #f8f8f8;
      border-radius: 23px;
      overflow: hidden;
      .left {
        flex: 1;
        display: flex;
        flex-direction: row;
        align-items: center;
        ::v-deep {
          .van-search {
            padding: 0;
            width: 100%;
            background: #f8f8f8;
            align-items: center;
            .van-field {
              padding: 0;
            }
            .van-field__left-icon {
              display: flex;
              align-items: center;
            }
          }
        }
        .searchIcon {
          // margin-top: 2px;
          width: 24px;
          height: 24px;
        }
      }
      .line {
        margin: 0 10px;
        background: #eaedf0;
        width: 1px;
        height: 13px;
      }
      .searchButton {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #3476fe;
        line-height: 20px;
      }
    }
    ::v-deep {
      .van-tabs__wrap {
        height: 55px;
        .van-tabs__nav {
          border-color: rgb(51, 51, 51);
          display: flex;
          justify-content: space-around;
        }
        .van-tab {
          flex: auto;
          padding: 0;
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #999999;
          line-height: 16px;
        }
        .van-tab--active {
          font-size: 16px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #333333;
        }
      }
      .van-tabs__line {
        width: 10px;
        height: 3px;
        background: #333333;
        border-radius: 2px;
      }
    }
  }
  .result {
    box-sizing: border-box;
    height: 100%;
    padding: 30px 20px 0;
    background: #fff;
    .loading-box {
      text-align: center;
    }
    .api-card {
      margin-bottom: 30px;
      .top {
        margin-bottom: 8px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .title {
          max-width: 260px;
          font-size: 16px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #333333;
          line-height: 22px;
          word-break: break-all;
          white-space: pre-wrap;
        }
        .tag {
          padding: 0 8px;
          display: flex;
          align-items: center;
          justify-content: center;
          min-width: 40px;
          height: 21px;
          background: rgba(52, 118, 254, 0.1);
          border-radius: 4px;
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #3476fe;
          line-height: 17px;
        }
      }
      .info {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
        line-height: 20px;
        .hospital {
          .item {
            display: flex;
            align-items: center;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #999999;
            line-height: 20px;
            margin-bottom: 5px;
            .icon {
              width: 20px;
              height: 20px;
            }
            //   .text {
            //   }
          }
        }
        .service {
          display: flex;
          align-items: center;
          .img {
            min-width: 90px;
            height: 60px;
            margin-right: 10px;
          }
          .text {
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;
            word-break: break-all;
          }
        }
        .product {
          .text {
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            word-break: break-all;
          }
        }
      }
    }
  }
  .nodata-bg {
    padding-top: 57px;
    background: linear-gradient(#fff 0%, #f5f8ff 100%);
    box-shadow: 0px 15px 30px 0px #f5f8ff;
  }
  .empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    .icon {
      margin-bottom: 10px;
    }
  }
  .empty-pc {
    position: relative;
    // background: linear-gradient(#ffffff, rgba(52, 118, 254, 0.05));
    display: flex;
    flex-direction: column;
    align-items: center;
    .icon-no {
      // margin-bottom: 10px;
      width: 311px;
      height: 221px;
    }
    .top-text {
      position: absolute;
      left: 0;
      top: 0;
      padding-left: 14px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #999999;
      line-height: 22px;
    }
    .pc-info {
      width: 100%;
      ::v-deep {
        .component {
          .crm {
            margin: 0;
            padding: 0;
            .header {
              padding-left: 0;
              padding-right: 0;
            }
            .pc_bg {
              text-align: center;
              margin: 0;
            }
          }
        }
      }

      .btn-box {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 40px;
        margin-bottom: 20px;
        height: 44px;
        background: linear-gradient(90deg, #6496ff 0%, #3476fe 100%);
        border-radius: 22px;
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
        line-height: 22px;
      }
      .have {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 45px;
        .text {
          font-size: 14px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #333333;
          line-height: 20px;
        }
        .icon {
          width: 16px;
          height: 16px;
        }
      }
    }
  }
}
</style>
